<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 统计报表
                </el-breadcrumb-item>
				<el-breadcrumb-item>采购统计</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.orderCompanyId" placeholder="请选择公司" filterable>
					<el-option key="" label="请选择公司" value=""></el-option>
					<el-option v-for="item in channelsKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-date-picker
					type="datetime"
					placeholder="开始时间"
					v-model="query.createTimeStart"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="结束时间"
					v-model="query.createTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="companyName" label="渠道名称" width="350">
				</el-table-column>
				<el-table-column prop="num" label="订单数量"></el-table-column>
				<el-table-column prop="includeTaxTotal" label="含税订单金额"></el-table-column>
				<el-table-column prop="noTaxTotal" label="未税订单金额" v-if=showNoTax></el-table-column>
				<el-table-column prop="paidTotal" label="已支付金额"></el-table-column>
				<el-table-column prop="invoicingTotal" label="已开票金额"></el-table-column>
				<el-table-column prop="unbilledTotal" label="未开票金额"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
							v-if="controll['show'] && scope.row.companyName != '合计'"
                            @click="handleShow(scope.$index, scope.row)"
                        >详情</el-button>
						<!--<el-button
                            type="text"
                            icon="el-icon-tickets"
                            @click="handleShow(scope.$index, scope.row)"
                        >分析</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
			<div class="total-info">
				<div class="total-info-item">
					订单数量：{{totalData.orderNum}}
				</div>
				<div class="total-info-item">
					订单金额：￥{{totalData.orderAmountTotal}}
				</div>
				<div class="total-info-item">
					已开发票：￥{{totalData.invoicingTotal}}
				</div>
				<div class="total-info-item">
					未开发票：￥{{totalData.unbilledTotal}}
				</div>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		<el-dialog v-dialogDrag :close-on-click-modal=false :title="showTitle" :visible.sync="showVisible" width="75%">
			<el-form ref="show" :model="show" label-width="100px">
				<el-table
					:data="detailList"
					border
					class="table"
					header-cell-class-name="table-header"
					:cell-style="{padding:1+'px'}"
					height="410px"
					stripe
				>
					<el-table-column prop="monthStr" label="月份"></el-table-column>
					<el-table-column prop="num" label="订单数量"></el-table-column>
					<el-table-column prop="includeTaxTotal" label="含税订单金额"></el-table-column>
					<el-table-column prop="noTaxTotal" label="未税订单金额" v-if=showNoTax></el-table-column>
					<el-table-column prop="paidTotal" label="已支付金额"></el-table-column>
					<el-table-column prop="invoicingTotal" label="已开票金额"></el-table-column>
					<el-table-column prop="unbilledTotal" label="未开票金额"></el-table-column>
					</el-table>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { getPurchaseTotal, getChannelKV, getPurchaseOrderTotalDetail, isShowNoTax } from '../../../api/index';
export default {
    name: 'purchase-total',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            pageTotal: 0,
            form: {},
			show: {},
            idx: -1,
            id: -1,
			channelsKV:[],
			totalData:{},
			detailList:[],
			showVisible:false,
			showTitle:'',
			showNoTax:false,
			controll:{}
        };
    },
    created() {
		this.controll = getControll("purchase-total");
		this.getShowNoTax();
		this.getChannels();
        this.getData();
    },
    methods: {
		getShowNoTax() {
			isShowNoTax().then(res => {
				if (res.code == 0) {
					this.showNoTax = res.data;
				} else {
					this.$message.error(`获取显示配置失败！` + res.message);
				}
			});
		},
		// 获取数据
        getData() {
            getPurchaseTotal(this.query).then(res => { 
				if (res.code == 0 ) {
					this.totalData = res.data;
					this.tableData = res.data.pager.records;
					this.pageTotal = res.data.pager.total;
					let num = 0;
					let includeTaxTotal = 0;
					let noTaxTotal = 0;
					let paidTotal = 0;
					let invoicingTotal = 0;
					let unbilledTotal = 0;
					for (var i = 0; i < this.tableData.length; i++) {
						num = this.tableData[i].num + num;
						includeTaxTotal = this.tableData[i].includeTaxTotal + includeTaxTotal;
						noTaxTotal = this.tableData[i].noTaxTotal + noTaxTotal;
						paidTotal = this.tableData[i].paidTotal + paidTotal;
						invoicingTotal = this.tableData[i].invoicingTotal + invoicingTotal;
						unbilledTotal = this.tableData[i].unbilledTotal + unbilledTotal;
					}
					let totalRecord = {};
					totalRecord.companyName = "合计";
					totalRecord.num = num;
					totalRecord.includeTaxTotal = includeTaxTotal.toFixed(2);
					totalRecord.noTaxTotal = noTaxTotal.toFixed(2);
					totalRecord.paidTotal = paidTotal.toFixed(2);
					totalRecord.invoicingTotal = invoicingTotal.toFixed(2);
					totalRecord.unbilledTotal = unbilledTotal.toFixed(2);
					this.tableData.push(totalRecord);
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		//获取渠道
		getChannels() {
			getChannelKV().then(res => {
				if (res.code == 0) {
					this.channelsKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		// 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleShow(index, row) {
			let showQuery = {};
			this.$set(showQuery, 'orderCompanyId', row.companyId);
			this.$set(showQuery, 'createTimeStart', this.query.createTimeStart);
			this.$set(showQuery, 'createTimeEnd', this.query.createTimeEnd);
			this.showTitle = '采购统计详情（' + row.companyName + '）';
			getPurchaseOrderTotalDetail(showQuery).then(res => {
				if (res.code == 0) {
					this.detailList = res.data;
					this.showVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    width: 40px;
    height: 30px;
}
.total-info {
	float:left; 
	padding-top:25px;
}
.total-info-item {
	float:left; 
	padding-right:20px;
	padding-left:10px;
	color:#606266;
	font-size:15px;
}
.text {
	font-size: 14px;
}

.item {
	margin-bottom: 18px;
	border-bottom:1px solid #E0E0E0;
}
</style>
